import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import ContentCardGrid from './ContentCardGrid';
import FeaturedTags from './FeaturedTags';
import NavBar from './NavBar';
import {
  handleActiveProject,
  handleFeaturedTags,
} from './helpers/navigationHelper';

const Featured = ({ content }: { content: Content }) => {
  const [searchParameters, setSearchParameters] = useSearchParams();
  const navigate = useNavigate();

  const { featured, categories, projects, cards } = content;
  const { title, description, action } = featured;

  const featuredProjects = projects
    .filter((project) => project.featured === true)
    .toSorted((a, b) => a.title.localeCompare(b.title));

  useEffect(() => {
    if (searchParameters.toString()) {
      setSearchParameters({});
    }
  }, []);

  return (
    <div className="featured">
      <NavBar
        isFeatured={true}
        projects={[]}
        isSearching={false}
        setIsSearching={() => {}}
        setSearchedProjects={() => {}}
      />
      <div className="featured-content">
        <div className="intro">
          <span className="title">{title}</span>
          <span className="description">{description}</span>
        </div>
        <ContentCardGrid
          projects={featuredProjects}
          handleActiveProject={handleActiveProject}
          cardsAction={cards.action}
          isFeatured={true}
          navigate={navigate}
          searchParameters={searchParameters}
        />
        <div className="featured-action">
          <span>{action}</span>
        </div>
        <FeaturedTags
          categories={categories}
          handleFeaturedTags={handleFeaturedTags}
          navigate={navigate}
        />
      </div>
    </div>
  );
};

export default Featured;
